module.exports = __webpack_public_path__ + "img/COMP.79dc59d9.svg";